import React from "react";
import "./TermosDeUso.css";
import ComponentHome1 from "../Home2/components/componentHome1";
import ComponentHome6 from "../Home2/components/componentHome6";
import Header from "../../components/Header";
import FooterHome from "../Home2/components/FooterHome";

const TermosDeUso = () => {
    return (
        <>
            <Header />


            <div className="termos-container">
                <h1>Termos de Uso</h1>

                <p>
                    Estes Termos de Uso regem o acesso e uso deste site/aplicativo. Ao
                    utilizar nossos serviços, você concorda com os termos aqui descritos.
                </p>

                <h2>1. Aceitação dos Termos</h2>
                <p>
                    Ao acessar ou utilizar o site/aplicativo, você concorda em cumprir estes
                    Termos de Uso, bem como nossa Política de Privacidade.
                </p>

                <h2>2. Uso Permitido</h2>
                <ul>
                    <li>Você deve utilizar este serviço apenas para fins legais;</li>
                    <li>É proibido utilizar o site para atividades fraudulentas ou abusivas;</li>
                    <li>O uso indevido da plataforma pode resultar na suspensão da conta.</li>
                </ul>

                <h2>3. Propriedade Intelectual</h2>
                <p>
                    Todo o conteúdo disponível no site (textos, imagens, logos, códigos, etc.)
                    é de propriedade exclusiva da empresa ou de terceiros licenciados, sendo
                    protegido por leis de direitos autorais e propriedade intelectual.
                </p>

                <h2>4. Responsabilidades</h2>
                <ul>
                    <li>Não garantimos que o serviço estará disponível de forma ininterrupta;</li>
                    <li>Não nos responsabilizamos por danos causados por uso indevido da plataforma;</li>
                    <li>É responsabilidade do usuário manter a confidencialidade de suas credenciais.</li>
                </ul>

                <h2>5. Modificações dos Termos</h2>
                <p>
                    Reservamo-nos o direito de alterar estes Termos de Uso a qualquer momento.
                    Recomendamos que você revise esta página regularmente.
                </p>
 
            </div>
            <FooterHome />
        </>
    );
};

export default TermosDeUso;
